module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving2-cfe022a5515c3e8c3788b9fdf2c5497a.jpg";